export enum SessionStorage {
  ImpersonationSession = 'impersonationSession',
  SubscriptionId = 'subscription',
}
